import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferBatchDeliverTimeQuery } from './type';

/**
 * c端offer管理中心 批量修改offer的发货时间 数字商品/game service offer
  POST /product/offerManage/updateDeliveryTime
  接口ID：263628555
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628555
 */
export const postOfferDeliveryTime = (data: OfferBatchDeliverTimeQuery[]): AxiosPromise => {
  return request({
    url: '/product/offerManage/updateDeliveryTime',
    method: 'post',
    data
  });
};
